import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthFacade } from '@curbnturf/auth/src/lib/+state/auth.facade';
import { Role } from '@curbnturf/entities';
import { StatusFacade } from '@curbnturf/status/src/lib/status.facade';
import { ModalController } from '@ionic/angular/standalone';
import { Subscription } from 'rxjs';
import { AuthModalFacade } from '../+state/auth-modal.facade';
import { LoginModalComponent } from '../login-modal/login-modal.component';
import { NewPasswordModalComponent } from '../new-password-modal/new-password-modal.component';
import { RecoverModalComponent } from '../recover-modal/recover-modal.component';
import { RegisterModalComponent } from '../register-modal/register-modal.component';

@Component({
  selector: 'curbnturf-auth-modals',
  templateUrl: './auth-modals.component.html',
  styleUrls: ['./auth-modals.component.scss'],
  standalone: true,
  imports: [],
})
export class AuthModalsComponent implements OnDestroy, OnInit {
  authModalSubscription: Subscription;
  onHideSubscription: Subscription;

  modal?: HTMLIonModalElement;

  loggedIn: boolean;
  role?: Role;

  private subscriptions: Subscription[] = [];

  constructor(
    private authFacade: AuthFacade,
    private modalController: ModalController,
    private modalFacade: AuthModalFacade,
    private statusFacade: StatusFacade,
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.statusFacade.loggedIn$.subscribe((loggedIn) => {
        this.loggedIn = loggedIn;
      }),
      this.authFacade.tempRole$.subscribe((role) => (this.role = role)),
      this.modalFacade.modal$.subscribe(async (modalToOpen) => {
        if (!modalToOpen) {
          // don't close the modal if the modal is already closed or doesn't exist
          const modal = await this.modalController.getTop();
          if (modal) {
            await this.modalController.dismiss();
          }
        } else {
          switch (modalToOpen) {
            case 'login': {
              await this.modal?.dismiss('reopen');
              this.modal = await this.modalController.create({
                component: LoginModalComponent,
                componentProps: {
                  inModal: true,
                },
                cssClass: 'auth-modal login',
              });
              await await this.modal.present();
              break;
            }
            case 'newPassword': {
              await this.modal?.dismiss('reopen');
              this.modal = await this.modalController.create({
                component: NewPasswordModalComponent,
                cssClass: 'auth-modal new-password',
              });
              await await this.modal.present();
              break;
            }
            case 'recover': {
              await this.modal?.dismiss('reopen');
              this.modal = await this.modalController.create({
                component: RecoverModalComponent,
                componentProps: {
                  inModal: true,
                },
                cssClass: 'auth-modal recover',
              });
              await await this.modal.present();
              break;
            }
            case 'register': {
              await this.modal?.dismiss('reopen');
              this.modal = await this.modalController.create({
                component: RegisterModalComponent,
                componentProps: {
                  inModal: true,
                },
                cssClass: 'auth-modal register',
              });
              await await this.modal.present();
              break;
            }
            default: {
              if (this.modal) {
                await this.modal.dismiss('reopen');
                delete this.modal;
              }
            }
          }

          this.modal?.onDidDismiss().then((event) => {
            if (event?.data !== 'reopen') {
              this.modalFacade.openAuthModal();
            }
          });
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
